var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("@/assets/icons/webmd_icon.png"),"alt":"webmd icon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }